"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Network {
    constructor({ baseURL, version }) {
        this.baseURL = baseURL;
        this.version = version;
    }
    get endpoint() {
        return [this.baseURL, `v${this.version}`].join('/');
    }
}
exports.default = Network;
Network.production = new Network({
    baseURL: 'https://api.helium.io',
    version: 1,
});
Network.staging = new Network({
    baseURL: 'https://api.helium.wtf',
    version: 1,
});
Network.testnet = new Network({
    baseURL: 'https://testnet-api.helium.wtf',
    version: 1,
});
//# sourceMappingURL=Network.js.map